<script>
import { BModal } from 'bootstrap-vue';
import { Alert } from '../../services/alert';
import dayjs from '../../core/dayjs';

const csvAndXlsxData = [
  { identifier: 'deals', line: 'Negócios' },
  { identifier: 'activities', line: 'Atividades' },
];

const pdfData = [
  { identifier: 'deals.started', line: 'Negócios iniciados', order: 0 },
  { identifier: 'deals.closed', line: 'Negócios fechados', order: 1 },
  { identifier: 'deals.lost', line: 'Negócios perdidos', order: 2 },
  { identifier: 'users.deals.started', line: 'Usuários com mais negócios iniciados', order: 3 },
  { identifier: 'users.deals.closed', line: 'Usuários com mais negócios ganhos', order: 4 },
  { identifier: 'users.deals.lost', line: 'Usuários com mais negócios perdidos', order: 5 },
  { identifier: 'activities.started', line: 'Atividades iniciadas', order: 6 },
  { identifier: 'activities.closed', line: 'Atividades finalizadas', order: 7 },
  { identifier: 'activities.pending', line: 'Atividades a finalizar', order: 8 },
  { identifier: 'activities.successful', line: 'Atividades finalizadas com sucesso', order: 9 },
  { identifier: 'activities.unsuccessful', line: 'Atividades finalizadas sem sucesso', order: 10 },
  { identifier: 'activities.deleted', line: 'Atividades excluídas', order: 11 },
  { identifier: 'chart.deal.started', line: 'Negócios iniciados', order: 12 },
  { identifier: 'chart.deal.won', line: 'Negócios ganhos', order: 13 },
  { identifier: 'chart.deal.lost', line: 'Negócios perdidos', order: 14 },
  { identifier: 'chart.deal.progress', line: 'Progresso de negócios', order: 15 },
  { identifier: 'chart.deal.conversion', line: 'Conversão de negócios para negócios fechados', order: 16 },
];

export default {
  components: {
    BModal,
  },

  props: ['title', 'range', 'user', 'pipeline'],

  data () {
    return {
      selectedDealsTypes: [],
      source: 'progress',
      data: { lines: csvAndXlsxData },
      isExporting: false,
      selectedLines: [],
      exportTypes: ['csv', 'xlsx', 'pdf'],
      selectedExportType: 'csv',
      search: '',
      allCheckboxesState: 'none'
    };
  },

  async mounted () {
    Bus.$on('openExportModal', () => {
      this.selectAllLines();

      this.openModal();
    });

    Bus.$on('exportGraphsError', this.handleExportGraphsError);
  },

  watch: {
    selectedExportType (type) {
      if (type === 'pdf') {
        this.data.lines = pdfData;

        return this.selectAllLines();
      }

      this.data.lines = csvAndXlsxData;

      return this.selectAllLines();
    }
  },

  computed: {
    dateRangeText () {
      const range = this.getRange();

      const [from, to] = range.split(' > ');

      const formattedFrom = from.replaceAll('-', '/');
      const formattedTo = to.replaceAll('-', '/');

      return `Período de: ${formattedFrom} à ${formattedTo}`;
    },

    filteredLines () {
      return this.data.lines.filter((line) => {
        const lowerCaseSearch = this.search.toLowerCase();
        const lowerCaseLine = line.line ? line.line.toLowerCase() : '';

        return lowerCaseLine.includes(lowerCaseSearch);
      });
    },

    allCheckboxesStateText () {
      return this.allCheckboxesState === 'all' ? 'Todos' : 'Nenhum';
    }
  },

  methods: {
    openModal () {
      this.$refs['export-modal'].show();
    },

    hideModal () {
      Bus.$emit('exportProgressModalHidden');

      this.$refs['export-modal'].hide();
    },

    handleModalShown () {
      Bus.$emit('exportProgressModalShown');
    },

    getRange () {
      if (!this.range) {
        const to = dayjs();
        const from = dayjs().subtract(14, 'day');

        return `${from.format('DD-MM-YYYY')} > ${to.format('DD-MM-YYYY')}`;
      }

      return this.range;
    },

    selectAllLines () {
      this.allCheckboxesState= 'none';
      this.selectedLines = this.data.lines.map((line) => JSON.stringify(line));
    },

    unselectAllLines () {
      this.allCheckboxesState= 'all';
      this.selectedLines = [];
    },

    handleExportGraphsError (error) {
      console.error(error);
      Alert.error('Erro ao exportar gráficos');

      this.isExporting = false;
      this.resetData();
      this.hideModal();
    },

    toggleCheckboxesState () {
      const state = this.allCheckboxesState;

      if (state === 'none') {
        this.unselectAllLines();
        return this.allCheckboxesState = 'all';
      }

      this.selectAllLines();
      return this.allCheckboxesState = 'none';
    },

    extractFilters () {
      const filters = { in: [] }
      const innerFilters = [];

      if (this.pipeline.id) {
        const pipelineFilter = {
          field: 'pipelines.id',
          operator: '=',
          query: this.pipeline.id,
        };

        innerFilters.push(pipelineFilter);
      }

      if (this.user.id) {
        const userFilter = {
          field: 'users.id',
          operator: '=',
          query: this.user.id,
        };

        innerFilters.push(userFilter);
      }

      filters.in.push(innerFilters);
      return filters.in[0].length > 0 ? filters : null;
    },

    resetData() {
      this.selectedDealsTypes = [];
      this.selectedLines = [];
    },

    extractProgressData () {
      return this.selectedLines.map((jsonLine) => JSON.parse(jsonLine))
        .sort((a, b) => a.order - b.order)
        .map((line) => line.identifier);
    },

    async handleSubmit () {
      this.isExporting = true;

      if (this.selectedLines.length === 0) {
        this.isExporting = false;
        return Alert.error('É necessário ao menos um campo a ser exportado');
      }

      if (!this.selectedExportType) {
        this.isExporting = false;
        return Alert.error('Por favor selecione o formato da exportação');
      }

      const progressData = this.extractProgressData();
      const filters = this.extractFilters();

      if (this.selectedExportType === 'pdf') {
        new Promise((resolve) => {
          this.selectedDealsTypes = this.selectedLines.filter((selectedLine) => {
            const jsonSelectedLineIdentifier = JSON.parse(selectedLine).identifier;
            if (
              jsonSelectedLineIdentifier === 'deals.started' ||
              jsonSelectedLineIdentifier === 'deals.closed' ||
              jsonSelectedLineIdentifier === 'deals.lost'
            ) {
              return jsonSelectedLineIdentifier
            }
          }).map((stringifySelectedDealsTypes) => JSON.parse(stringifySelectedDealsTypes).identifier);

          Bus.$emit('selectedDealsTypes', this.selectedDealsTypes);
          resolve();
        }).then(() => {
            Bus.$emit('parseHtmlToCanvasAndCreateAnImage', {
              callback: (progressImages) => {
                this.exportProgress(progressImages, filters, progressData)
              },
              progressData
            });
        })
      } else {
        this.exportProgress([], filters, progressData);
      }
    },

    async exportProgress(progressImages, filters, progressData) {
      if (filters === null || Object.keys(filters).length === 0) {
        filters = {};
      }

      if (progressImages == null) {
        progressImages = [];
      }

      this.$http
        .post(`/export/progress/${this.source}/${this.selectedExportType}`, {
          range: this.getRange(),
          progressData,
          filters,
          files: progressImages
        })
        .then(() => {
          Alert.success('Exportação em andamento');
        })
        .catch(() => {
          Alert.error('Algo deu errado ao exportar os seus dados');
        })
        .finally(() => {
          this.resetData();
          this.selectAllLines();
          this.isExporting = false;
          this.hideModal();
          this.$forceUpdate();
        });

      this.$forceUpdate();
    }
  },
};
</script>

<template>
  <BModal
    id="export-modal"
    ref="export-modal"
    hide-footer="hide-footer"
    hide-header="hide-header"
    centered
    @shown="handleModalShown"
  >
    <button
      class="close-button"
      type="button"
      aria-label="Fechar"
      v-on:click="hideModal"
    >
      <span aria-hidden="true">×</span>
    </button>

    <header class="d-flex flex-column justify-content-center align-items-center">
      <h2 class="export-modal-title">
        {{ title }}
      </h2>
      <p class="mb-0 text-salesflow-font-gray">{{ pipeline.name }}</p>
      <p class="mb-0 text-salesflow-font-gray">Usuário: {{ user.name }}</p>
      <p class="mb-0 text-salesflow-font-gray">{{ dateRangeText }}</p>
    </header>

    <form
      id="export-modal-form"
      @submit.prevent="handleSubmit"
    >
      <input
        id="export-modal-search-input"
        type="text"
        placeholder="Digite e pressione enter para pesquisar..."
        v-model="search"
      >

      <section class="w-100 d-flex flex-column justify-content-center align-items-center">
        <div class="w-100 d-flex justify-content-between align-items-center mb-2">
          <span class="export-modal-label">Selecione os dados que deseja exportar</span>
          <button
            id="toggle-export-options-button"
            type="button"
            @click="toggleCheckboxesState"
          >
            {{ allCheckboxesStateText }}
          </button>
        </div>
        <div class="export-items-container">
          <div class="export-items-list">
            <div
              v-for="(line, index) of filteredLines"
              :key="index"
              class="export-item"
            >
              <input
                :id="`export-modal-line-${index}`"
                :value="JSON.stringify(line)"
                v-model="selectedLines"
                type="checkbox"
              >
                <!-- @change="onCheckboxChange" -->
              <span class="export-item-text ml-1">{{ line.line }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="w-100 d-flex flex-column justify-content-center">
        <label class="export-modal-label" for="export-type-select">Exportar relatório como</label>
        <select
          id="export-type-select"
          name="export-type-select"
          v-model="selectedExportType"
        >
          <option
            v-for="type of exportTypes"
            :value="type"
          >
            {{ type.toUpperCase() }}
          </option>
        </select>
      </section>

      <button
        id="export-modal-button"
        class="salesflow-btn salesflow-btn-secondary"
        :disabled="isExporting"
      >
        <i
          v-if="isExporting"
          class="fa fa-circle-o-notch fa-spin"
        />
        <span
          v-else
        >
          Exportar
        </span>
      </button>

      <button
        class="cancel-button"
        type="button"
        v-on:click="hideModal"
      >
        Cancelar
      </button>
    </form>
  </BModal>
</template>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #export-modal {
    .modal-dialog {
      max-width: 540px;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      margin: 0px auto;

      .modal-content {
        border-radius: 16px;
        overflow: hidden;
      }

      .modal-body {
        padding: 2rem 5rem 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        background-color: $salesflow-bg-content;

        #export-modal-form {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          padding: 0px;
          margin: 0px;
        }

        .export-modal-title {
          @include salesflow-title($font-weight: 500);
          margin-bottom: 0px;
        }

        #toggle-export-options-button {
          padding: 0px;
          margin: 0px;
          outline: 0px;
          border: 0px;
          background-color: transparent;

          @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
        }

        #export-modal-search-input {
          width: 100%;
          padding: 0.75rem 1.5rem;
          background-color: $salesflow-bg-content;
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 14px;
          outline: none;
          @include salesflow-text();

          &::placeholder {
            color: $salesflow-font-gray;
          }
        }

        .export-modal-label {
          @include salesflow-text($font-weight: 500);
        }

        .export-items-container {
          width: 100%;
          height: 232px;
          overflow: hidden;
          background-color: white;
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 14px;
          padding-right: 0.25rem;
        }

        .export-items-list {
          padding: 0.5rem 0.75rem 0.5rem 1rem;
          width: 100%;
          height: 232px;
          overflow: auto;

          .export-item {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 1rem 0px;

            &:not(:last-child) {
              border-bottom: 1px solid $salesflow-outline-gray-medium;
            }

            .export-item-text {
              @include salesflow-text;
            }

            .export-item-value {
              @include salesflow-text($color: $salesflow-font-gray);
            }
          }
        }

        #export-type-select {
          width: 100%;
          padding: 16px 12px;
          background-color: white;
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 8px;

          @include salesflow-text($color: $salesflow-font-gray, $font-weight: 500);
        }

        #export-modal-button {
          max-width: fit-content;
          min-width: 8rem;

          &:focus {
            outline: 0px;
          }

          &:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }
        }

        .cancel-button {
          padding: 0px;
          margin: 0px;
          border: 0px;
          outline: 0px;
          background-color: transparent;
          @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
          text-decoration: underline;

          &:hover {
            color: $salesflow-purple-dark;
          }
        }

        .close-button {
          position: absolute;
          top: 16px;
          right: 18px;
          background-color: transparent;
          border: 0px;
          outline: 0px;
          padding: 0px;
          margin: 0px;

          font-size: 2rem;
          line-height: 1.5rem;
          color: $salesflow-font-gray;
          background-color: transparent;
        }
      }
    }
  }
</style>
